import SelectFixo from "../../SelectFixo";

function SelectEmpresa({campoEmpresa, onChangeEmpresa, isMulti = false}){
    const optionsEmpresas = JSON.parse(localStorage.getItem('empresasOptions'))

    return (
        <SelectFixo 
            options={optionsEmpresas} 
            value={campoEmpresa} 
            isLabel={true} 
            label="Empresa/Filial" 
            multiple={isMulti}
            onChange={(e) => onChangeEmpresa(e)}
        />
    )
}

export default SelectEmpresa;